import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import sidebarData from "./SidebarData";
//Simple bar
import SimpleBar from "simplebar-react";
// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../../components/Common/withRouter";
import { Link } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

const Sidebar = (props) => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }
    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag
        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);
  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }
        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");
            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };
  const activeMenu = useCallback(() => {
    const pathName = props.router.location.pathname;
    const fullPath = pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu-item");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);
  useEffect(() => {
    ref.current.recalculate();
  }, []);
  useEffect(() => {
    new MetisMenu("#side-menu-item");
    activeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    activeMenu();
  }, [activeMenu]);
  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const closeMobileSidebar = () => {
    if (window.innerWidth <= 998) {
      document.body.classList.remove("sidebar-enable");
    }
  };

  const [anpr, setAnpr] = React.useState(false);
  const [inout, setInout] = React.useState(false);

  useEffect(() => {
    setAnpr(props.appConfig?.modules?.anpr);

    const current_version = props.appConfig?.version_db;
    if (current_version && compareVersions(current_version, "1.2.124")) {
      setInout(1);
    }
    else
      setInout(0);

  }, [props.appConfig]);

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu-item">
              {(sidebarData || []).map((item, key) => {
                if (item.module == "anpr" && anpr !== 1) return null; /// ANPR Module
                if (
                  item.module == "resumeDay" &&
                  compareVersions(props.appConfig?.version_db, "1.2.173") ===
                    false
                )
                  return null; /// RESUME DIARIO - TIENE QUE TENER VERSION 1.2.173 en adelante
                if (item.module == "inout" && inout !== 1) return null;
                // Tarifario solo aparece si el cliente sincroniz\u00f3 su tariffs
                if (item.requiresTariffs && !props.tariffs) return null;
                // Items que requieren app_config cargado (ej. Permisos de
                // Operadores lee app_config.permissions.oper).
                if (
                  item.requiresAppConfig &&
                  (!props.appConfig || Object.keys(props.appConfig).length === 0)
                )
                  return null;
                // Versión mínima del cliente (tc_qml). Compara contra version_app
                // (versión real de la app). Fallback a version_db para clientes
                // viejos que aún no envían version_app.
                const clientVersion =
                  props.appConfig?.version_app ||
                  props.appConfig?.version_db ||
                  "";
                if (
                  item.minVersion &&
                  compareVersions(clientVersion, item.minVersion) === false
                )
                  return null;
                // Resolver label según versión del cliente: si el item tiene
                // `labelV2` y la app está en v2.0+, usar el nuevo nombre.
                const major = parseInt((clientVersion.split(".")[0] || "0"), 10);
                const isV2 = !isNaN(major) && major >= 2;
                const displayLabel = item.labelV2 && isV2 ? item.labelV2 : item.label;

                // Filtrar subItems según sus propias condiciones.
                // Si tiene subItem y todos los hijos quedan ocultos, ocultar
                // también el padre (evita "Gestión" vacío).
                let visibleSubItems = item.subItem;
                if (item.subItem) {
                  visibleSubItems = item.subItem.filter((s) => {
                    if (s.requiresTariffs && !props.tariffs) return false;
                    if (
                      s.requiresAppConfig &&
                      (!props.appConfig ||
                        Object.keys(props.appConfig).length === 0)
                    )
                      return false;
                    // Secciones sensibles (Permisos, Informes, Accesos a
                    // Monitor): solo visibles para usuarios con Gestión.
                    // Tarifario se ve siempre — tiene valor read-only.
                    if (s.requiresEditPermission && !props.canEditTariffs)
                      return false;
                    return true;
                  });
                  if (visibleSubItems.length === 0) return null;
                }

                // Si queda un único subitem visible, "promover" a top-level:
                // evita un submenú colapsado con un solo hijo. Ej: usuario
                // sin Gestión ve solo "Tarifario" y no "Gestión > Tarifario".
                if (
                  visibleSubItems &&
                  visibleSubItems.length === 1 &&
                  item.subItem.length > 1
                ) {
                  const only = visibleSubItems[0];
                  return (
                    <li key={key}>
                      <Link
                        to={only.link || "/#"}
                        className=" "
                        onClick={closeMobileSidebar}
                      >
                        <span
                          className="material-symbols-rounded"
                          style={{ marginRight: 5, fontSize: 20 }}
                        >
                          {item.icon}
                        </span>
                        <span>{props.t(only.sublabel)}</span>
                      </Link>
                    </li>
                  );
                }
                return (
                  <React.Fragment key={key}>
                    {item.isMainMenu ? (
                      <li className="menu-title">{props.t(displayLabel)}</li>
                    ) : (
                      <li key={key}>
                        <Link
                          to={item.url ? item.url : "/#"}
                          className={
                            item.issubMenubadge || item.isHasArrow
                              ? " "
                              : "has-arrow"
                          }
                          onClick={item.url ? closeMobileSidebar : undefined}
                        >
                          <span
                            className="material-symbols-rounded"
                            style={{ marginRight: 5, fontSize: 20 }}
                          >{item.icon}</span>
                          {item.issubMenubadge && (
                            <span
                              className={
                                "badge rounded-pill float-end " + item.bgcolor
                              }
                            >
                              {" "}
                              {item.badgeValue}{" "}
                            </span>
                          )}
                          <span>{props.t(displayLabel)}</span>
                          {item.pill && (
                            <span
                              className={
                                "badge rounded-pill bg-" +
                                (item.pill.color || "secondary")
                              }
                              style={{
                                marginLeft: 8,
                                fontSize: 10,
                                fontWeight: 600,
                                padding: "3px 7px",
                                lineHeight: 1,
                                verticalAlign: "middle",
                                position: "relative",
                                top: -1,
                              }}
                            >
                              {props.t(item.pill.text)}
                            </span>
                          )}
                        </Link>
                        {visibleSubItems && visibleSubItems.length > 0 && (
                          <ul className="sub-menu">
                            {visibleSubItems.map((item, key) => (
                              <li key={key}>
                                <Link
                                  to={item.link}
                                  className={
                                    item.subMenu && "has-arrow waves-effect"
                                  }
                                  onClick={item.link ? closeMobileSidebar : undefined}
                                >
                                  {props.t(item.sublabel)}
                                </Link>
                                {item.subMenu && (
                                  <ul className="sub-menu">
                                    {item.subMenu.map((item, key) => (
                                      <li key={key}>
                                        <Link to="#">
                                          {props.t(item.title)}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        </SimpleBar>
      </div>
    </React.Fragment>
  );
};

function compareVersions(v1, v2) {
  try {
    if (!v1 || !v2) return false;
    const v1Parts = v1.split(".").map(Number);
    const v2Parts = v2.split(".").map(Number);

    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
      const v1Part = v1Parts[i] || 0; // Si no hay más partes, se considera como 0
      const v2Part = v2Parts[i] || 0;

      // console.log("Comparando:", v1Part, "vs", v2Part);

      if (v1Part > v2Part) return true; // v1 es mayor
      if (v1Part < v2Part) return false; // v1 es menor
    }

    return true; // Son iguales, por lo que v1 >= v2
  } catch (error) {
    console.error("Error al comparar versiones:", error);
    return false;
  }
}

Sidebar.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  appConfig: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    appConfig: state.data.appConfig,
    tariffs: state.data.tariffs,
    canEditTariffs: state.data.canEditTariffs,
  };
};

// Exporta el componente envuelto con connect, withRouter y withTranslation
export default connect(mapStateToProps)(withRouter(withTranslation()(Sidebar)));
